import { useState, useEffect } from "react";
import { AlertCircle, CheckCircle } from "lucide-react";
import { cn } from "@/lib/utils";

const ValidationIndicator = ({ field, className = "" }) => {
  const { isValidating, isTouched, errors, isValid } = field.state.meta;
  const [hasValidated, setHasValidated] = useState(false);
  const [wasValidating, setWasValidating] = useState(false);
  
  // Check if field has async validation configured
  const hasAsyncValidation = !!(
    field.options.validators?.onChangeAsync ||
    field.options.validators?.onBlurAsync ||
    field.options.validators?.onSubmitAsync
  );
  
  // Track validation state transitions
  useEffect(() => {
    if (isValidating && !wasValidating) {
      // Validation just started
      setWasValidating(true);
      setHasValidated(false);
    } else if (!isValidating && wasValidating) {
      // Validation just finished
      setWasValidating(false);
      setHasValidated(true);
    }
  }, [isValidating, wasValidating]);
  
  // Only show indicator if async validation is configured
  if (!hasAsyncValidation) return null;
  
  let icon = null;
  
  if (isValidating) {
    icon = <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin" />;
  } else if (errors.length > 0) {
    icon = <AlertCircle size={20} className="text-destructive" />;
  } else if (hasValidated && errors.length === 0) {
    // Show success only after validation has actually completed and passed
    icon = <CheckCircle size={20} className="text-green-600" />;
  }
  
  if (!icon) return null;
  
  return (
    <div className={cn("absolute top-1/2 right-3 transform -translate-y-1/2", className)}>
      {icon}
    </div>
  );
};

export { ValidationIndicator };